import { render } from "./SamRegister.vue?vue&type=template&id=6bb223be&scoped=true"
import script from "./SamRegister.vue?vue&type=script&lang=js"
export * from "./SamRegister.vue?vue&type=script&lang=js"

import "./SamRegister.vue?vue&type=style&index=0&id=6bb223be&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb223be"]])

export default __exports__